import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';

function HostModal(props) {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [remark_boarding, setremark_bording] = useState('')
    const navigate = useNavigate();
    const remarkBoarding = (event) => {
        setremark_bording(event.target.value)
    }
console.log(props.GetAllStudentsHost ,"approved_host_data")
    const hostApproveHanler = () => {
        const form_data = {};
        const approved_host_data = { ...props.item }
        form_data['remark_boarding'] = remark_boarding
        form_data['student_host_id'] = approved_host_data['student_host_id'];
        form_data['is_host_approved'] = true;
        props.onApproveHost(form_data).then((response) => {
            if (response.success === true) {
                toast.success(response.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
                // setTimeout(() => {
                //     navigate("/leave/manage-host")
                // }, 100);
                handleClose()
                props.GetAllStudentsHost()
   
            } else {
                toast.error(response.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        });
    }

    return (
        <>
            {props.disabled ? (
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>Parent approval is pending, that's why it's disabled.</Tooltip>}
                >
                    <span style={{ display: 'inline-block', cursor: 'not-allowed' }}>
                        <Button variant="primary" size="sm" disabled style={{ pointerEvents: 'none' }}>Unapproved</Button>
                    </span>
                </OverlayTrigger>
            ) : (
                <Button variant="primary" size="sm" onClick={handleShow}>Unapproved</Button>
            )}
           
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Approve Host</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {props.item?.is_rejected_by_parent && (
                        <div style={{ backgroundColor: '#fff3f3', border: '1px solid #f5c2c2', borderRadius: '6px', padding: '10px 14px', marginBottom: '12px' }}>
                            <p style={{ color: 'red', fontWeight: '600', fontSize: '13px', marginBottom: '4px' }}>Rejected by Parent</p>
                            <p style={{ color: '#555', fontSize: '12px', marginBottom: '0' }}>If you still want to approve this host, you can continue by clicking <strong>Approve</strong>.</p>
                        </div>
                    )}
                    <Form>
                        <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlTextarea1"
                        >
                            <Form.Label>Add Remark</Form.Label>
                            <Form.Control as="textarea" rows={3} onChange={(event) => remarkBoarding(event)} />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className='btn-sm' onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" className='btn-sm' onClick={() => hostApproveHanler()}>Approve</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default HostModal;